import React, { useState, useEffect } from "react";
import Thumbnail from "./DcmThumbnail/thumbnail";
import SagittalView from "./Viewer/SagittalView";
import AxialView from "./Viewer/AxialView";

import { EventEmitter } from "../../event";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


import { formatDisc, getNameAfterSplit, SliceEnum } from "../common/codeHelper";
import { getSliceThumbnailName } from "../../service/api.service";
import { Tooltip } from "react-tippy";


// import Feedback from "../common/Feedback";
// import { useParams } from "react-router-dom";

let state = {
    boneName: '',
    saggitalImageData: [],
    filterListAxialData: [],
    filterListSagittalData: [],
    axialImageData: [],
    analysisMap: undefined,
    analysisName: undefined,
    activeAnalysis: '',
    thumbnailInput: []
}

let patientAnalysis = '';


let discList = [];

// let filterList= [];

function Dcm(props) {

    const [filterListAxial, setFilterListAxial] = useState(state.filterListAxialData);
    const [filterListSagittal, setFilterListSagittal] = useState(state.filterListSagittalData);
    const [saggitalImageData, setSaggitalImageData] = useState(state.saggitalImageData);
    const [axialImageData, setAxialImageData] = useState(state.axialImageData);
    const [thumbnailInput, setThumbnailInput] = useState([]);
    const [activeAnalysis, setActiveAnalysis] = useState(state.activeAnalysis);
    const [boneName, setBoneName] = useState(state.boneName);
    const [analysisName, setAnalysisName] = useState();
 

    // const handleCloseFeedbackDialog = () => {
    //     setOpenFeedbackDialog(false);
    // };

    function handleCallbackSelection(count) {
        let name = `L${count}_L${count + 1}`;
        if (count === 5) {
            name = `L${count}_S1`;
        }
        if (state.boneName !== name) {
            state.boneName = name;
            setBoneName(name);
        }
        const axialData = state.analysisMap.get(`${SliceEnum.AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL}@${state.boneName}`);
        if (axialData) {
            state.axialImageData = axialData[0].sliceInfos;
            setAxialImageData(axialData[0].sliceInfos);
        } else {
            state.axialImageData = [];
            setAxialImageData([]);
        }
        const dataForThumbnail = state.analysisMap.get(`${state.activeAnalysis}@${state.boneName}`);
        if (dataForThumbnail) {
            if (thumbnailInput !== dataForThumbnail) {
                state.thumbnailInput = dataForThumbnail;
                setThumbnailInput(dataForThumbnail);
            }
        } else {
            state.thumbnailInput = [];
            setThumbnailInput([]);
        }

        if (state.boneName) {
            if (axialData)
                EventEmitter.dispatch("dropdownSelectChangeAxial", axialData[0].sliceInfos);
            else
                EventEmitter.dispatch("dropdownSelectChangeAxial", []);
        }
        // }
    }

    useEffect(() => {
        if(!analysisName){
            getSliceThumbnailName(data => {
                state.analysisName = data;
                setAnalysisName(data);
            })
        }
        if (props.patientAnalysis && (patientAnalysis !== props.patientAnalysis || !patientAnalysis)) {
           
            getData();

        }
        if (props.patientAnalysis && state.thumbnailInput.length && state.analysisMap && boneName && (thumbnailInput && thumbnailInput.length === 0)) {
            setTimeout(() => {
                setThumbnail()
            }, 300);
        }
    });

    function setThumbnail() {
        if (thumbnailInput && thumbnailInput.length === 0) {
            const dataForThumbnail = state.analysisMap.get(`${state.activeAnalysis}@${state.boneName}`);
            if (dataForThumbnail) {
                if (thumbnailInput !== dataForThumbnail) {
                    state.thumbnailInput = dataForThumbnail;
                    setThumbnailInput(dataForThumbnail);
                }
            } else {
                state.thumbnailInput = [];
                setThumbnailInput([]);
            }
        }
    }

    const getData = () => {
        state.activeAnalysis = '';
        setActiveAnalysis(state.activeAnalysis);
        state.thumbnailInput = [];
        setThumbnailInput([]);
        state.boneName = '';
        setBoneName('');
        patientAnalysis = props.patientAnalysis;
        state.analysisMap = new Map();
        discList = [];
        state.filterListAxialData = []; state.filterListSagittallData = [];
        patientAnalysis.spinaAnalysis.analysisOutputs.forEach(element => {
            const key = `${element.outputType}@${element.diskCode}`;
            const dataValue = state.analysisMap.get(key);
            if (dataValue) {
                dataValue.push(element);
                state.analysisMap.set(key, dataValue);
            } else {
                state.analysisMap.set(key, [element]);
            }
            if (!state.filterListAxialData.includes(element.outputType) && element.plane === 'AXIAL' && element.diskCode !== 'ALL' && element.outputType !== SliceEnum.AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL) {
                state.filterListAxialData.push(element.outputType);
            }
            if (!state.filterListSagittalData.includes(element.outputType) && element.plane === 'SAGITTAL' && element.diskCode !== 'ALL' && element.outputType !== SliceEnum.AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL) {
                state.filterListSagittalData.push(element.outputType);
            }
            if (element.outputType === SliceEnum.SAGITTAL_SEGMENTATION_RESULT_MEDICAL_MODEL) {
                state.saggitalImageData = element.sliceInfos
                setSaggitalImageData(element.sliceInfos);
            }
            if (element.outputType === SliceEnum.AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL) {
                discList = [...discList, element.diskCode];
                if (!state.boneName && (element.diskCode === 'L1_L2' || element.diskCode === 'L3_L4')) {
                    setDataAsPerDiskSelected(element.diskCode)
                } else {
                    const axialData = state.analysisMap.get(`${SliceEnum.AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL}@${state.boneName}`);
                    if (axialData) {
                        state.axialImageData = axialData[0].sliceInfos;
                        setAxialImageData(axialData[0].sliceInfos);
                    } else {
                        state.axialImageData = [];
                        setAxialImageData([]);
                    }
                }
            }
        });
        setFilterListAxial(state.filterListAxialData);
        setFilterListSagittal(state.filterListSagittalData);
    }

    function handleCallbackSaggital(ev) {
        EventEmitter.dispatch("saggitalSelectChange", ev);
    }

    function showChangedAnalysis(evName) {
        state.activeAnalysis = evName;
        setActiveAnalysis(evName);
        const name = `${evName}@${state.boneName}`;
        const data = state.analysisMap.get(name);
        if (data) {
            if (thumbnailInput !== data) {
                state.thumbnailInput = data;
                setThumbnailInput(data);
            }
        } else {
            state.thumbnailInput = [];
            setThumbnailInput([]);
        }
    }

    const setDataAsPerDiskSelected = (bname) => {
        state.boneName = bname;
        setBoneName(bname);
        if (state.activeAnalysis) {
            const name = `${activeAnalysis}@${state.boneName}`;
            const data = state.analysisMap.get(name);
            if (data) {
                if (thumbnailInput !== data) {
                    state.thumbnailInput = data;
                    setThumbnailInput(data);
                }
            } else {
                state.thumbnailInput = [];
                setThumbnailInput([]);
            }
        }
        const axialData = state.analysisMap.get(`${SliceEnum.AXIAL_SEGMENTATION_RESULT_MEDICAL_MODEL}@${state.boneName}`);
        if (axialData) {
            state.axialImageData = axialData[0].sliceInfos;
            setAxialImageData(axialData[0].sliceInfos);
        } else {
            state.axialImageData = [];
            setAxialImageData([]);
        }
        EventEmitter.dispatch("sliceDataChange", axialData[0].sliceInfos);
        if (bname === 'L1_L2') {
            EventEmitter.dispatch("dropdownSelectChange", 1);
        } else if (bname === 'L2_L3') {
            EventEmitter.dispatch("dropdownSelectChange", 2);
        } else if (bname === 'L3_L4') {
            EventEmitter.dispatch("dropdownSelectChange", 3);
        } else if (bname === 'L4_L5') {
            EventEmitter.dispatch("dropdownSelectChange", 4);
        } else if (bname === 'L5_S1') {
            EventEmitter.dispatch("dropdownSelectChange", 5);
        }
    }
    const handleChangeDropdown = (event) => {
        setDataAsPerDiskSelected(event.target.value)

    };


    const getAnalysisName = (name) => { 
            if (analysisName) {
                return <div>{analysisName[name]}</div>;
            } else {
                 getSliceThumbnailName(data => {
                    state.analysisName = data;
                    setAnalysisName(data);
                    return <div>{data[name]}</div >;
                })
             }
     }

    var discListOutput = discList.map((char, index) => {
        return (
            <MenuItem value={char} key={index}>{formatDisc(char)}</MenuItem>
        );
    });

    var ThumbnailDiv = thumbnailInput.map((item, index) =>
        <div className="grid grid-cols-4 gap-1 mb-2 " key={index}>
            {
                item.sliceInfos.map((slice, subindex) =>
                    <div key={subindex}>
                        <Thumbnail data={slice} name={item.plane + ' ' + formatDisc(item.diskCode) + ' ' + state.analysisName[activeAnalysis] + ' Slice: ' + slice.sliceNumber} />
                    </div>
                )
            }

        </div>
    );
    return (

        <div id="outer-div" >
            <div className={'grid grid-cols-10 gap-2 mb-0 mt-4'}>
                <div className={'animate__animated animate__fadeInLeft col-span-1 border   border-green-600 bg-[#a9d3ac] text-black'}>
                    <div className={'left-more-img overflow-x-hidden   overflow-y-auto'}>
                        <div>
                            <div className="cursor-pointer text-black  " >
                                <div className="axial-analysis animate__animated animate__zoomIn">
                                    <div className="py-4  p-2   bg-[#211E3B] font-semibold  text-white shadow-inner install-element text-center text-lg ">
                                        AXIAL<div className="arrow-down"></div>
                                    </div>
                                    {filterListAxial.map(
                                        (name, index) => {
                                            return <div key={index} onClick={() => showChangedAnalysis(name)} className={`banner ${activeAnalysis === name ? "active-thumb" : ""}`}>
                                                <div className={`   border-green-600 text-white slider-center`}>
                                                    <Tooltip
                                                        position="bottom-end"
                                                        html={(
                                                            <div>
                                                                <strong>
                                                                    {analysisName && getAnalysisName(name)}
                                                                </strong>
                                                            </div>
                                                        )}
                                                    >
                                                        {analysisName && getAnalysisName(name)}
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className="sagittal-analysis animate__animated animate__zoomIn">
                                    <div className=" p-2 py-4 bg-[#211E3B] text-white font-semibold shadow-inner text-center text-lg ">
                                        SAGITTAL<div className="arrow-down"></div>
                                    </div>
                                    {filterListSagittal.map(
                                        (name, index) => {
                                            return <div key={index} onClick={() => showChangedAnalysis(name)} className={`banner ${activeAnalysis === name ? "active-thumb" : ""}`}>
                                                <div className={`  text-white border-green-600  slider-center`}>
                                                    <Tooltip
                                                        position="bottom-end"
                                                        html={(
                                                            <div>
                                                                <strong>
                                                                    {analysisName && getAnalysisName(name)}
                                                                </strong>
                                                            </div>
                                                        )}
                                                    >
                                                        {analysisName && getAnalysisName(name)}
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className={'col-span-9   '}>
                    <div className="grid grid-cols-10 gap-3 content-center">
                        <div className="col-span-2 p-1 border border-blue-400 ">
                            <div className=" mb-2 shadow-md">
                                <SagittalView
                                    sliceData={{ saggitalImageData }}
                                    diskCoOrdinates={props?.patientAnalysis?.spinaAnalysis?.diskCoOrdinates}
                                    totalSaggitalImage={saggitalImageData.length}
                                    currentIndex={Math.floor(saggitalImageData.length / 2)}
                                    ChangeSelectionCallback={handleCallbackSelection}
                                />
                            </div>
                            <div className="mb-2 select-disk">
                                <FormControl fullWidth size="small">
                                    <InputLabel id="disc-select-label" className="disc-label">Disc</InputLabel>
                                    <Select
                                        labelId="disc-select-label"
                                        id="simple-select"
                                        value={boneName}
                                        label="Disc"
                                        onChange={handleChangeDropdown}
                                    >
                                        {discListOutput}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="w-full shadow-md">
                                <div>
                                    <AxialView sliceData={{ axialImageData }} saggitalCallback={handleCallbackSaggital} />
                                </div>
                            </div>
                        </div>
                        <div className="col-span-8  animate__animated animate__fadeInRight">
                            <div className="h-full">
                                <div className='flex flex-wrap w-full h-full  '>
                                    <div className="overflow-y-scroll analysis-desc w-full">
                                        {activeAnalysis &&
                                            <div className="pb-2 pt-1 px-2">
                                                <div className="text-xl font-semibold text-blue-800">{getAnalysisName(activeAnalysis)}</div>
                                                {thumbnailInput[0]?.predictionText &&
                                                    <div className="text-base  ">
                                                        {
                                                            getNameAfterSplit(thumbnailInput[0]?.predictionText, '@', 0)} : {getNameAfterSplit(thumbnailInput[0]?.predictionText, '@', 1)}
                                                    </div>
                                                }
                                            </div>
                                        }
                                        <div >

                                            {ThumbnailDiv}
                                            <div >
                                                {(thumbnailInput.length === 0 && activeAnalysis) &&
                                                    <div>No data available</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Dcm;











